import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'ucfirst'})
export class UcfirstPipe implements PipeTransform {
  transform(value: number): string {
    return (typeof value === 'undefined' || value === null) ? '' : capitalizeFirstLetter(snakeToCamel(value));
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function snakeToCamel(string) {
  return string.replace(/(\_[a-z])/g, ($1) => $1.toUpperCase().replace('_', ' '));
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/ucfirst.pipe.ts